/** Create the first conversation once, with another attempt available after failure. */
export async function attemptInitialSession<T>(
  attempted: { current: boolean },
  getUserDefaultAgentId: () => Promise<string | null>,
  getTenantDefaultAgentId: () => Promise<string | null>,
  create: (agentId: string | null) => Promise<T | null>,
): Promise<T | null> {
  if (attempted.current) return null;
  attempted.current = true;

  try {
    // Preference lookup is optional. A fresh account can still start with the
    // tenant default when preferences are temporarily unavailable.
    const userDefault = await getUserDefaultAgentId().catch(() => null);
    const agentId = userDefault ?? await getTenantDefaultAgentId().catch(() => null);
    const session = await create(agentId);
    if (!session) attempted.current = false;
    return session;
  } catch {
    attempted.current = false;
    return null;
  }
}
